<template>
  <a
    rel="noopener noreferrer"
    target="_blank"
    class="whatsapp-button"
    :style="style"
    :href="link"
  >
    {{content}}
  </a>
</template>

<script>
import aboutMixin from '@/mixins/aboutMixin';

export default {
  mixins: [aboutMixin],
  computed: {
    style() {
      return `width: ${this.width}px; height: ${this.height}px; background-size: ${this.width}px ${this.height}px;`;
    },
  },
  data() {
    return {
      content: '',
    };
  },
  props: {
    /**
     * @description ссылка на телеграм
     */
    link: {
      type: String,
      default: aboutMixin.supportWhatsappHref,
    },
    /**
     * @description Высота
     * @type Number
     */
    height: {
      type: Number,
      default: 24,
    },
    /**
     * @description Ширина
     * @type Number
     */
    width: {
      type: Number,
      default: 22,
    },
  },
};

</script>

<style scoped lang="scss">
  .whatsapp-button {
    background: url("@/assets/img/social/whats-app-green.svg") no-repeat center;
    transition: 0.3s;
    &:hover {
      opacity: 0.8;
    }
    &:active {
      transform: scale(0.95);
    }
  }
</style>
